/* CUSTOMIZATION JS */

(function() {
  // Compute header height and set it as a CSS variable
  function computeAndSetHeaderHeight() {
    const announcementBar = document.querySelector(".mount-announcement-bar");
    const scrollingText = document.querySelector(".mount-scrolling-text");
    const header = document.querySelector(".mount-header");
    let headerHeight = 0;

    if (announcementBar) {
      headerHeight += announcementBar.offsetHeight;
    }
    if (scrollingText) {
      headerHeight += scrollingText.offsetHeight;
    }
    if (header) {
      headerHeight += header.offsetHeight;
    }
    document.documentElement.style.setProperty("--header-height-computed", `${headerHeight}px`);

    /* const addToCartBtn = document.querySelector(".product--add-to-cart-form .product__add-to-cart");
    if (addToCartBtn) {
      const openCustomizationBtn = document.getElementById("openCustomizationButton");
      if (openCustomizationBtn) {
        openCustomizationBtn.style.width = `${addToCartBtn.getBoundingClientRect().width}px`;
      }
    } */
  }
  setTimeout(computeAndSetHeaderHeight, 1000);
  window.addEventListener('resize', computeAndSetHeaderHeight);

  document.querySelector(".pop_up_wrapper .close_button").addEventListener('click', (e) => {
    document.querySelector(".pop_up_wrapper").style.display = "none";
  });
  document.querySelector(".pop_up_wrapper .confirm_button").addEventListener('click', (e) => {
    document.querySelector(".pop_up_wrapper").style.display = "none";
  });
  document.querySelector(".pop_up_wrapper .background").addEventListener('click', (e) => {
    document.querySelector(".pop_up_wrapper").style.display = "none";
  });

  // CUSTOM ELEMENT
  if (!customElements.get('custom-personalisation')) {
    class CustomPersonalisation extends HTMLElement {
      constructor() {
        super();

        // Define elements
        this.bodyElem = document.querySelector('body');
        this.productVariantsElem = document.querySelector('product-variants');
        this.openButtonElem = document.getElementById("openCustomizationButton");
        this.formElem = this.querySelector('#personalisationForm');
        this.cssSliderElem = this.querySelector('.images_panel css-slider');
        this.closeButtonElem = this.querySelector('.close_button');
        this.priceTotalElem = this.querySelector('.price_total');
        this.selectedSizeElem = this.querySelector('.size_value');
        this.radioFontElems = this.querySelectorAll('input[type=radio][name="font"]');
        this.maxTextSizeLabelElems = this.querySelectorAll('.max_text_size');
        this.firstTextInput = this.querySelector('#FirstLineInput');
        this.secondTextInput = this.querySelector('#SecondLineInput');
        this.textOnFullImageElem = this.querySelector('#textOnFullImage');
        this.textOnZoomImageElem = this.querySelector('#textOnZoomImage');
        this.radioSecondLineElems = this.querySelectorAll('input[type=radio][name="second_line"]');
        this.radioSymbolElems = this.querySelectorAll('input[type=radio][name="symbol"]');
        this.secondLineTextInputWrapperElem = this.querySelector('.second_line_text_input_wrapper');
        this.secondLineSymbolInputWrapperElem = this.querySelector('.second_line_symbol_input_wrapper');
        this.secondLineSymbolTabElems = this.querySelectorAll('.symbols_category_tab');
        this.addToCartButton = this.querySelector('.addToCartButton');

        // Define variables
        this.currentVariantId = this.dataset.variantId;
        this.maxTextSize = 15;
        this.firstTimeOpen = true;

        // Init events, size and others
        if (this.productVariantsElem) {
          this.handleVariantChange();
        }
        this.bindEvents();
        this.computeTextAndSymbolSize();

        // Allow display after initialization
        this.style.display = "block";
      }

      // Bind events
      bindEvents() {
        // Open personalisation button in product page
        this.openButtonElem.addEventListener('click', this.open.bind(this));
        
        // Close icon in personalisation modal
        this.closeButtonElem.addEventListener('click', this.close.bind(this));

        // Handle window resize
        window.addEventListener('resize', () => {
          // Wait a bit for CSS-Slider to transform DOM
          setTimeout(() => {
            this.computeSecondLineWrapperHeight();
            this.handleTextInput();
            this.computeTextAndSymbolSize();
          }, 500);
        });

        // Handle variant change
        if (this.productVariantsElem) {
          this.productVariantsElem.addEventListener('VARIANT_CHANGE', this.handleVariantChange.bind(this));
        }

        // Handle font selector change
        this.radioFontElems.forEach(radio => radio.addEventListener('change', () =>  {
          this.cssSliderElem.classList.remove('futura_font', 'script_font', 'goudy_font');
          this.cssSliderElem.classList.add(`${radio.value.split(' ')[0].toLowerCase()}_font`);
        }));
        
        // Handle text inputs change
        this.firstTextInput.addEventListener('input', this.handleTextInput.bind(this));
        this.secondTextInput.addEventListener('input', this.handleTextInput.bind(this));

        // Handle second line text button click
        this.radioSecondLineElems.forEach(radio => radio.addEventListener('change', () =>  {
          switch (radio.value) {
            case "text":
              this.resetSecondLineSymbolInput();
              this.secondLineTextInputWrapperElem.style.height = 'var(--height)';
              this.secondLineSymbolInputWrapperElem.style.overflow = "hidden";
              break;
            case "symbol":
              this.resetSecondLineTextInput();
              this.secondLineSymbolInputWrapperElem.style.height = 'var(--height)';
              this.secondLineSymbolInputWrapperElem.style.overflow = "visible";
              break;
            default:
              this.resetSecondLineTextInput();
              this.resetSecondLineSymbolInput();
              this.secondLineSymbolInputWrapperElem.style.overflow = "hidden";
              break;
          }
        }));

        // Handle symbol category change
        this.secondLineSymbolTabElems.forEach(tab => tab.addEventListener('click', (e) => {
          // Remove active class from all tabs
          this.secondLineSymbolTabElems.forEach(t => t.classList.remove('active'));
          // Add active class to the clicked tab
          e.currentTarget.classList.add('active');

          // Show only symbols from the selected category
          const selectedCategory = e.currentTarget.dataset.tab;
          const symbols_wrappers = this.secondLineSymbolInputWrapperElem.querySelectorAll('.engraving_symbol_items_wrapper');
          symbols_wrappers.forEach(symbols_wrapper => {
            if (symbols_wrapper.dataset.tab === selectedCategory || selectedCategory === 'all') {
              symbols_wrapper.style.display = 'flex';
            } else {
              symbols_wrapper.style.display = 'none';
            }
          });

          this.computeSecondLineWrapperHeight();
          this.secondLineSymbolInputWrapperElem.style.overflow = "visible";
        }));

        // Handle symbol selector change
        this.radioSymbolElems.forEach(radio => radio.addEventListener('change', (e) => this.handleSymbolChange(e)));

        // Handle form submit
        this.formElem.addEventListener('submit', (e) => {
          e.preventDefault();
          this.addToCartButton.classList.add('working');
          this.handleFormSubmit(new FormData(e.target));
        });

        // Handle phone scroll up button
        this.querySelector('#PhoneScrollUp').addEventListener('click', (e) => {
          e.preventDefault();

          // Scroll to top smoothly
          this.querySelector('.personalisation_wrapper').scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        });
      }

      // Reset second line text input
      resetSecondLineTextInput() {
        this.secondTextInput.value = '';
        this.handleTextInput();
        this.secondLineTextInputWrapperElem.style.height = '0';
      }

      // Reset second line symbol input
      resetSecondLineSymbolInput() {
        this.secondLineSymbolInputWrapperElem.querySelector("#No_symbol").click();
        this.secondLineSymbolInputWrapperElem.style.height = '0';
      }

      // Reset text on images
      resetTextOnImages() {
        this.textOnFullImageElem.querySelector(".first_line").innerText = "";
        this.textOnFullImageElem.querySelector(".second_line .text").innerText = "";
        this.textOnZoomImageElem.querySelector(".first_line").innerText = "";
        this.textOnZoomImageElem.querySelector(".second_line .text").innerText = "";
        // Remove any existing symbol from the text
        this.textOnFullImageElem.querySelector('.symbol')?.remove();
        this.textOnZoomImageElem.querySelector('.symbol')?.remove();
      }

      // Reset form
      resetForm() {
        this.formElem.reset();
        this.resetTextOnImages();
        this.addToCartButton.classList.remove('working');
      }

      // Handle variant change
      handleVariantChange() {
        const currentVariant = this.productVariantsElem.currentVariant;
        this.currentVariantId = currentVariant.id;
        console.log("Current variant:", currentVariant);

        // Update the price total element
        this.priceTotalElem.textContent = this.format_money(Number(currentVariant.price) + Number(this.dataset.productCustomizationPrice));
        this.selectedSizeElem.textContent = currentVariant.title;
        

        // Update text max size
        switch (currentVariant.title) {
          case '100 ml':
            this.maxTextSize = 15;
            break;
          case '50 ml':
            this.maxTextSize = 13;
            break;
          case '30 ml':
            this.maxTextSize = 13;
            break;
          default:
            this.maxTextSize = 15;
            break;
        }
        this.maxTextSizeLabelElems.forEach(label => label.textContent = `${this.maxTextSize}`);
        this.firstTextInput.setAttribute('maxlength', this.maxTextSize);
        this.secondTextInput.setAttribute('maxlength', this.maxTextSize);
        
        // Trim the text inputs if they exceed the max size
        if (this.firstTextInput.value.length > this.maxTextSize) {
          this.firstTextInput.value = this.firstTextInput.value.slice(0, this.maxTextSize);
        }
        if (this.secondTextInput.value.length > this.maxTextSize) {
          this.secondTextInput.value = this.secondTextInput.value.slice(0, this.maxTextSize);
        }
        // Update the text in images
        this.handleTextInput();
      }

      // Compute text size
      computeTextAndSymbolSize() {
        // Need to reselect elements as CSS-Slider might have change DOM
        this.textOnFullImageElem = this.querySelector('#textOnFullImage');
        this.textOnZoomImageElem = this.querySelector('#textOnZoomImage');

        const fullImageWidth = this.textOnFullImageElem.offsetWidth;
        const zoomImageWidth = this.textOnZoomImageElem.offsetWidth;

        // Set the text size based on the image width
        this.textOnFullImageElem.style.setProperty('--font-size', `calc(${fullImageWidth / this.maxTextSize}px * var(--font-size-multiplier, 1))`);
        this.textOnZoomImageElem.style.setProperty('--font-size', `calc(${zoomImageWidth / this.maxTextSize}px * var(--font-size-multiplier, 1))`);

        // Set the symbol size based on the image width
        this.textOnFullImageElem.querySelector('.symbol svg')?.setAttribute('width', `${(fullImageWidth / this.maxTextSize) * 2}`);
        this.textOnFullImageElem.querySelector('.symbol svg')?.setAttribute('height', `${(fullImageWidth / this.maxTextSize) * 2}`);
        this.textOnZoomImageElem.querySelector('.symbol svg')?.setAttribute('width', `${(zoomImageWidth / this.maxTextSize) * 2}`);
        this.textOnZoomImageElem.querySelector('.symbol svg')?.setAttribute('height', `${(zoomImageWidth / this.maxTextSize) * 2}`);
      }

      // Check if display is allowed
      isDisplayAllowed() {
        // Check if the text inputs are not empty and within the max size
        return this.firstTextInput.value.length > 0 && this.firstTextInput.value.length <= this.maxTextSize
            && this.secondTextInput.value.length <= this.maxTextSize;
      }

      // Handle text input change
      handleTextInput() {
        // Clean text to keep only latin letters
        const firstText = this.firstTextInput.value;
        const secondText = this.secondTextInput.value;
        let cleanText = firstText.replace(/[^a-zA-Z0-9-.&\ ]/gi, '');
        this.firstTextInput.value = cleanText;
        cleanText = secondText.replace(/[^a-zA-Z0-9-.&\ ]/gi, '');
        this.secondTextInput.value = cleanText;

        // Display only if allowed number of letters
        if (!this.isDisplayAllowed()) {
          this.resetTextOnImages();
          return;
        }

        // Update text in images
        this.textOnFullImageElem.querySelector(".first_line").innerText = this.firstTextInput.value;
        this.textOnFullImageElem.querySelector(".second_line .text").innerText = this.secondTextInput.value;

        this.textOnZoomImageElem.querySelector(".first_line").innerText = this.firstTextInput.value;
        this.textOnZoomImageElem.querySelector(".second_line .text").innerText = this.secondTextInput.value;

        // If a symbol is selected, handle it
        this.handleSymbolChange();
      }

      // Handle symbol change
      handleSymbolChange(event) {
        // If no text is entered, do not display symbol
        if (!this.isDisplayAllowed()) return;

        // Remove any existing symbol from the text
        this.textOnFullImageElem.querySelector('.symbol')?.remove();
        this.textOnZoomImageElem.querySelector('.symbol')?.remove();
        
        const target = event? event.target : this.querySelector('input[type=radio][name="symbol"]:checked');
        // If "No symbol" is selected, stop here
        if (target.value === "null") return;

        const selectedSymbol = target.parentElement.querySelector("label").innerHTML;

        // Create a new span for the symbol
        const symbolSpan = document.createElement('span');
        symbolSpan.className = 'symbol';
        symbolSpan.innerHTML = selectedSymbol;

        // Append the symbol to the text
        this.textOnFullImageElem.querySelector(".second_line").appendChild(symbolSpan);
        this.textOnZoomImageElem.querySelector(".second_line").appendChild(symbolSpan.cloneNode(true));

        // Set the symbol size
        this.computeTextAndSymbolSize();
      }

      // Handle form submit
      handleFormSubmit(formData) {
        // Remove symbol if "No symbol" is selected
        if (formData.get('symbol') === "null") {
          formData.delete('symbol');
        }

        const randomId = crypto.randomUUID();
        const items = {
          "items": [
            {
              quantity: 1,
              id: this.dataset.productCustomizationId,
              properties: {
                "Première ligne": formData.get('first_line'),
                "Deuxième ligne": formData.get('second_line_text'),
                "Symbole": formData.get('symbol'),
                "Font": formData.get('font'),
                "_personnalisation_ID": randomId
              }
            },
            {
              quantity: 1,
              id: this.currentVariantId,
              properties: {
                "_personnalisation_ID": randomId
              }
            }
          ]
        }
        const headers = new Headers({ 'Content-Type': 'application/json' });
        const request = {
          method: 'POST',
          headers: headers,
          body: JSON.stringify(items)
        };

        fetch('/cart/add.js', request)
        .then(function() {
          document.querySelector(".custom-personalisation").close();
          document.querySelector(".custom-personalisation").resetForm();
          document.querySelector(".custom-personalisation").resetTextOnImages();
          document.querySelector(".custom-personalisation").resetSecondLineTextInput();
          document.querySelector(".custom-personalisation").resetSecondLineSymbolInput();
          window.refreshCart();
          document.querySelector(".pop_up_wrapper").style.display = "flex";
        });
      }

      // Open the personalisation modal
      open() {
        // Scroll to top when modal opens
        window.scrollTo(0, 0);
        this.classList.add("open");
        this.bodyElem.style.overflowY = "hidden";
        // Compute text size in case image hadn't loaded yet
        this.computeTextAndSymbolSize();

        // Also set height for second line wrappers
        if (this.firstTimeOpen) {
          this.firstTimeOpen = false;
          this.computeSecondLineWrapperHeight();
          this.secondLineTextInputWrapperElem.style.height = '0';
          this.secondLineSymbolInputWrapperElem.style.height = '0';
          
          // Reset form and text
          this.resetForm();
          this.resetTextOnImages();
        }

        if (window.innerWidth < 769) {
          // Scroll to top of the personalisation wrapper
          this.querySelector('.personalisation_wrapper').scrollTo(0, this.formElem.offsetTop);
        }
      }

      // Compute and set the height of the second line input wrappers
      computeSecondLineWrapperHeight() {
        if (this.secondLineTextInputWrapperElem.style.height === "0px") {
          this.secondLineTextInputWrapperElem.style.height = "auto";
          this.secondLineTextInputWrapperElem.style.setProperty("--height", `${this.secondLineTextInputWrapperElem.offsetHeight}px`);
          this.secondLineTextInputWrapperElem.style.height = '0';
        } else {
          this.secondLineTextInputWrapperElem.style.setProperty("--height", `auto`);
          this.secondLineTextInputWrapperElem.style.setProperty("--height", `${this.secondLineTextInputWrapperElem.offsetHeight}px`);
        }
        this.secondLineSymbolInputWrapperElem.style.overflow = "hidden";
        if (this.secondLineSymbolInputWrapperElem.style.height === "0px") {
          this.secondLineSymbolInputWrapperElem.style.height = "auto";
          this.secondLineSymbolInputWrapperElem.style.setProperty("--height", `${this.secondLineSymbolInputWrapperElem.offsetHeight - 25}px`);
          this.secondLineSymbolInputWrapperElem.style.height = '0';
        } else {
          this.secondLineSymbolInputWrapperElem.style.setProperty("--height", `auto`);
          this.secondLineSymbolInputWrapperElem.style.setProperty("--height", `${this.secondLineSymbolInputWrapperElem.offsetHeight - 25}px`);
        }
      }

      // Close the personalisation modal
      close() {
        this.classList.remove("open");
        this.bodyElem.style.overflowY = "auto";
      }

      // Utility function to format money
      format_money(cents) {
        if (typeof cents === 'string') {
          cents = cents.replace('.', '');
        }
    
        let value = '';
        const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        const formatString = KROWN.settings.shop_money_format || moneyFormat;
    
        function formatWithDelimiters(number, precision, thousands, decimal) {
          thousands = thousands || ',';
          decimal = decimal || '.';
    
          if (isNaN(number) || number === null) {
            return 0;
          }
    
          number = (number / 100.0).toFixed(precision);
    
          const parts = number.split('.');
          const dollarsAmount = parts[0].replace(
            /(\d)(?=(\d\d\d)+(?!\d))/g,
            '$1' + thousands
          );
          const centsAmount = parts[1] ? decimal + parts[1] : '';
    
          return dollarsAmount + centsAmount;
        }
    
        switch (formatString.match(placeholderRegex)[1]) {
          case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
          case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
          case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
          case 'amount_no_decimals_with_space_separator':
            value = formatWithDelimiters(cents, 0, ' ');
            break;
          case 'amount_with_apostrophe_separator':
            value = formatWithDelimiters(cents, 2, "'");
            break;
        }
    
        return formatString.replace(placeholderRegex, value);
      }
    }

    customElements.define('custom-personalisation', CustomPersonalisation);
  }
})();